export default __webpack_public_path__ + "4c0c72479780646b929c29d321fbd54a.png";